import React from 'react';
import PropTypes from 'prop-types';
import styles from './SelectField.module.css';

const SelectField = ({ id, label, value, onChange, options, isDisabled = false }) => {
// Verificar se todas as opções são desabilitadas
const allDisabled = options.length > 0 && options.every(option => option.disabled);

// Verificar se temos a opção específica "NÃO POSSUI UNIDADES"
const hasNoUnitsOption = options.length === 1 && 
                        options[0].label === "NÃO POSSUI UNIDADES" && 
                        options[0].disabled;

// Renderização especial para o caso "NÃO POSSUI UNIDADES"
if (hasNoUnitsOption) {
  return (
    <div className={styles.formGroup}>
      <label htmlFor={id}>{label}</label>
      <div className={`${styles.formControl} ${styles.noUnitsField}`}>
        <em>NÃO POSSUI UNIDADES</em>
      </div>
    </div>
  );
}

// Caso normal: renderiza o select padrão
return (
  <div className={styles.formGroup}>
    <label htmlFor={id}>{label}</label>
    <select
      id={id}
      className={`${styles.formControl} ${isDisabled ? styles.disabled : ''}`}
      value={value}
      onChange={onChange}
      disabled={isDisabled}
    >
      {/* Só mostrar "Selecione" se não for todas as opções desabilitadas */}
      {!allDisabled && <option value="">Selecione</option>}

      {options.map((option, index) => (
        <option
          key={`${id}-${option.value || index}`}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </select>
  </div>
);
};

SelectField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool
    })
  ).isRequired,
  isDisabled: PropTypes.bool
};

SelectField.defaultProps = {
  isDisabled: false
};

export default SelectField;